export class RaceModel {
  raceList: string[];

  constructor({ raceList }: { raceList: string[] }) {
    this.raceList = raceList;
  }
}
